import React from "react";
import nextId from "react-id-generator";
import { Redirect, Route, Switch } from "react-router";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import Notification from "../../Portals/Notification/Notification";
import EmploymentComponent from "./EmploymentComponent/EmploymentComponent";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import PreferenceComponent from "./Preference/PreferenceComponent";
import QualificationComponent from "./Qualification/QualificationComponent";
import "./register-body.style.scss";
import UploadResume from "./UploadResume/UploadResume";
export default function RegisterBody({
  selectedStep,
  tempData,
  setSelectedStep,
}) {
  const context = React.useContext(MainContext);
  const { updateState, registrationStep } = context;
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });

  const completeItFunction = (num) => {
    let temp = registrationStep;
    temp[num] = { ...temp[num], skipped: false };
    updateState("registrationStep", [...temp]);
  };
  return (
    <div className="register-body-main">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <Switch>
        <Route
          path="/register/personal"
          render={() => (
            <PersonalDetails
              notification={notification}
              setNotification={setNotification}
              completeIt={() => {completeItFunction(0)}}
              currentRoute={() => setSelectedStep(tempData[0])}
              changeRoute={() => setSelectedStep(Constant["qualification"])}
            />
          )}
        />
        <Route
          path="/register/qualification"
          render={() => (
            <QualificationComponent
              notification={notification}
              setNotification={setNotification}
              completeIt={() => {completeItFunction(1)}}
              currentRoute={() => setSelectedStep(tempData[1])}
              changeRoute={() => setSelectedStep(Constant["employment"])}
            />
          )}
        />
        <Route
          path="/register/employment"
          render={() => (
            <EmploymentComponent
              notification={notification}
              setNotification={setNotification}
              completeIt={() => {completeItFunction(2)}}
              currentRoute={() => setSelectedStep(tempData[2])}
              changeRoute={() => setSelectedStep(Constant["preferences"])}
            />
          )}
        />
        <Route
          path="/register/preferences"
          render={() => (
            <PreferenceComponent
              notification={notification}
              setNotification={setNotification}
              completeIt={() => {completeItFunction(3)}}
              currentRoute={() => setSelectedStep(tempData[3])}
              changeRoute={() => setSelectedStep(Constant["resume"])}
            />
          )}
        />
        <Route
          path="/register/resume"
          render={() => (
            <UploadResume
              notification={notification}
              setNotification={setNotification}
              completeIt={() => {completeItFunction(4)}}
              currentRoute={() => setSelectedStep(tempData[4])}
              changeRoute={() => setSelectedStep(Constant["qualification"])}
            />
          )}
        />
        {/* <Route path="/register" render={() => <SigningUpPage />} /> */}
        <Redirect to={`/register/personal`} />
      </Switch>
    </div>
  );
}
const Constant = {
  personal: {
    keyId: nextId(),
    number: 1,
    title: "Personal Details",
    id: "personal",
  },
  qualification: {
    keyId: nextId(),
    number: 2,
    title: "Qualification",
    id: "qualification",
  },
  employment: {
    keyId: nextId(),
    number: 3,
    title: "Employment",
    id: "employment",
  },
  preferences: {
    keyId: nextId(),
    number: 4,
    title: "Your Preferences",
    id: "preferences",
  },
  resume: {
    keyId: nextId(),
    number: 5,
    title: "Your CV / Resume",
    id: "resume",
  },
};
